import { Routes, Route } from "react-router-dom";
import Nav from "./components/nav/nav.component";
import Home from "./routes/home/home.route";
import OurStory from "./routes/our-story/our-story.route";
import Testimony from "./routes/testimony/testimony.route";
import Courses from "./routes/courses/courses.route";
import Team from "./routes/team/team.route";
import Cybersecurity from "./routes/cyberSecurity/cyber-security.route";
import UIDesign from "./routes/ui-design/ui-design.route";
import AI from "./routes/ai-machine-learning/ai-machine-learning.route";
import TeamProfile from "./components/team-card/teamProfile";
import IOTautomation from "./routes/iot-automation/iotAutomation.route";
import "./App.css";
import Register from "./routes/register/register.route";
// import Developers from "./routes/developers/developers.route";
import Projects from "./routes/projects/projects.route";
import Foundation from "./routes/foundations/foundations.route";
import Bootcamp from "./routes/bootcamp/bootcamp.route";
import Workshop from "./routes/workshop/workshop.route";
import CephasKids from "./routes/cephas-kids/cephas-kids.route";
import "animate.css";
import AllCourses from "./routes/all-courses/all-courses.route";
import CourseDetail from "./routes/course-details/course-details";

const App = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<Nav />}
      >
        <Route
          path="/"
          element={<Home />}
        />
        <Route
          path="/testimony"
          element={<Testimony />}
        />
        <Route
          path="/our-story"
          element={<OurStory />}
        />
        <Route
          path="/courses/*"
          element={<Courses />}
        />
        <Route
          path="/team"
          element={<Team />}
        />

        <Route
          path="/cyberSecurity"
          element={<Cybersecurity />}
        />
        <Route
          path="/ai-machine-learning"
          element={<AI />}
        />
        <Route
          path="/ui-design"
          element={<UIDesign />}
        />

        <Route
          path="/iot-automation"
          element={<IOTautomation />}
        />

        <Route
          path="/team/:memberName"
          element={<TeamProfile />}
        />

        <Route
          path="/register"
          element={<Register />}
        />
        <Route
          path="/projects"
          element={<Projects />}
        />
        <Route
          path="/our-trainings"
          element={<Register />}
        />
        <Route
          path="/our-foundation"
          element={<Foundation />}
        />
        <Route
          path="/workshop"
          element={<Workshop />}
        />
        <Route
          path="/kids"
          element={<CephasKids />}
        />
        <Route
          path="/kids/all-courses"
          element={<AllCourses />}
        />
        <Route
          path="/kids/:id"
          element={<CourseDetail />}
        />
      </Route>
      <Route
        path="/bootcamp"
        element={<Bootcamp />}
      ></Route>
    </Routes>
  );
};

export default App;
